@if (hasSelection()) {
  <ion-card>
    <ion-card-content>
      <p class="fs-sm">
        <strong>{{ 'deca.search.selected_plate' | translate }}</strong>
      </p>

      <div class="search-plates">
        <span class="plate-number">
          @if (isWithoutPlateSelected()) {
            {{ 'deca.search.without_plate' | translate }}
          } @else {
            {{ selectedPlate() }}
          }
        </span>

        <ion-button
          type="button"
          fill="outline"
          size="small"
          (click)="changePlate()"
        >
          <ion-icon
            aria-hidden="true"
            slot="start"
            src="../assets/material-symbols/search_24dp.svg"
          ></ion-icon>
          {{ 'deca.search.change_plate' | translate }}
        </ion-button>
      </div>
    </ion-card-content>
  </ion-card>

  <lib-deca-today-list
    category="TODAY_DOCUMENTS_AS_DRIVER"
    [detailRoute]="detailRoute()"
  ></lib-deca-today-list>
} @else {
  <ion-card>
    <ion-card-content>
      <p class="fs-sm">
        <strong>{{ 'deca.search.select_plate' | translate }}</strong>
      </p>

      <form
        [formGroup]="searchForm"
        (ngSubmit)="selectPlate()"
      >
        <div class="search-plates">
          <ion-toggle
            justify="start"
            labelPlacement="end"
            [checked]="withoutPlate()"
            (ionChange)="onWithoutPlateChange($event.detail.checked)"
          >
            {{ 'deca.search.without_plate' | translate }}
          </ion-toggle>

          @if (!withoutPlate()) {
            <ion-input
              formControlName="plate"
              label="{{ 'deca.search.plate' | translate }}"
              labelPlacement="floating"
              fill="outline"
              mode="md"
              inputmode="text"
              placeholder="{{ 'deca.search.plate' | translate }}"
            ></ion-input>
          }

          <ion-button
            type="submit"
            fill="outline"
            [attr.aria-label]="'general.select' | translate"
          >
            <ion-icon
              slot="icon-only"
              src="../assets/material-symbols/search_24dp.svg"
            ></ion-icon>
          </ion-button>
        </div>
      </form>
    </ion-card-content>
  </ion-card>
}
